import React from 'react';
import GeneralAnalytics from '../GeneralAnalytics';
import './demoAnalytics.css';

/* Analysis Reports — the legacy "General Analytics" surface (pick a script + date range,
   generate/aggregate transcript analysis, view & download reports) embedded in the new UI.
   Calls the existing analytics endpoints on the agent server (3016). */
const DemoAnalyticsReports = () => (
  <div className="demo-analytics h-full overflow-y-auto pb-4 pr-1">
    <GeneralAnalytics />
  </div>
);

export default DemoAnalyticsReports;
